import i18n from './i18n';

// Single place that decides how numbers/dates are rendered per language — Intl renders
// Arabic-Indic digits (٠١٢٣٤٥٦٧٨٩) natively for 'ar-EG', so no manual digit-mapping table is
// needed. i18n.language is already one of our two actual language codes ('ar-EG'/'en-US' — see
// language-code.ts), so it's already a valid Intl locale with no translation step.
//
// Deliberately NOT for phone numbers or form-field values: phone numbers are always plain
// strings (never passed through Intl.NumberFormat) and field values are set directly as
// component props rather than run through these helpers or t()'s interpolation formatter (see
// the `format` option in i18n.ts), so both stay in Western digits automatically.

export const formatNumber = (value: number, options?: Intl.NumberFormatOptions): string =>
    new Intl.NumberFormat(i18n.language, options).format(value);

export const formatDate = (value: Date | string | number, options?: Intl.DateTimeFormatOptions): string =>
    new Intl.DateTimeFormat(i18n.language, options).format(new Date(value));

export const formatTime = (value: Date | string | number, options?: Intl.DateTimeFormatOptions): string =>
    new Intl.DateTimeFormat(i18n.language, { hour: 'numeric', minute: 'numeric', ...options }).format(new Date(value));

export const formatDateTime = (value: Date | string | number, options?: Intl.DateTimeFormatOptions): string =>
    new Intl.DateTimeFormat(i18n.language, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        ...options,
    }).format(new Date(value));
